import { ApolloClient, NormalizedCacheObject, useMutation } from '@apollo/client';
import { LinkFileContentData, LinkFileContentVars } from '../gql-types';

import ApolloClientService from '../services/ApolloClientService';
import Config from '../config';
import { FileContentAttributes } from 'shared/models/FileContent';
import GraphQL from '../gql';

let assetApolloClient: ApolloClient<NormalizedCacheObject> = null;

export const useLinkFile = () => {
  if (!assetApolloClient) {
    assetApolloClient = ApolloClientService.create(Config.ASSET_GQL);
  }

  const [
    _linkFilecontent,
    { loading: linkFileLoading, error: linkFileError, data: linkFileData }
  ] = useMutation<LinkFileContentData, LinkFileContentVars>(
    GraphQL.Mutation.LINK_FILECONTENT,
    {
      client: assetApolloClient
    }
  );

  const linkFileContent = async (input: FileContentAttributes) => {
    _linkFilecontent({
      variables: {
        input
      }
    });
  };

  return {
    linkFileContent,
    linkFileLoading,
    linkFileError,
    linkFileData
  };
};
